import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import urlBuilder from 'garaje/utils/url-builder';

interface ModelParams {
  page?: string;
  status?: string;
}

export default class HrisDashboardAdminApprovalsRoute extends Route {
  @service declare ajaxFetch: AjaxFetchService;

  controllerName = 'location-overview/hris-dashboard/admin-approvals';
  templateName = 'location-overview/hris-dashboard/admin-approvals';

  queryParams = {
    page: { refreshModel: true },
    status: { refreshModel: true },
  };

  async model(params: ModelParams): Promise<unknown> {
    const qs = new URLSearchParams();
    if (params.page) qs.append('page', params.page);
    if (params.status) qs.append('status', params.status);
    const path = `/admin-approvals${qs.toString() ? `?${qs}` : ''}`;
    try {
      return await this.ajaxFetch.request(urlBuilder.hrisLifecycle.url(path));
    } catch (err) {
      // Don't crash the tab if approvals can't be loaded (authz / transient error).
      // The controller getters fall back to empty lists when the model is absent.
      // eslint-disable-next-line no-console
      console.error('[hris-dashboard][admin-approvals] failed to load approvals:', err);
      return {};
    }
  }
}
